export default __webpack_public_path__ + "static/singleCardImg-ff5c04f3fba46189fd24f5851c499c64.webp";